import * as THREE from 'three';

const textureCache = new Map();

function loadTexture(path) {
  if (textureCache.has(path)) {
    return textureCache.get(path);
  }
  
  try {
    const texture = new THREE.TextureLoader().load(
      path,
      undefined, // onLoad
      undefined, // onProgress
      (error) => {
        console.error(`Failed to load texture: ${path}`, error);
      }
    );
    textureCache.set(path, texture);
    return texture;
  } catch (error) {
    console.error(`Error loading texture: ${path}`, error);
    // Return a fallback colored material
    return null;
  }
}

export function create_conteiner_picture_from_cargo_area_cuboid(
  cube1,
  group_of_cargo_area_attribute,
  options = {}
) {
  const {
    opacity = 0.9,
    showWireframe = false,
    texturePaths = {
      side: './conteiner_side.png',
      front: './conteiner_front.png'
    }
  } = options;

  // Validate input
  if (!cube1 || !group_of_cargo_area_attribute) {
    console.error('Missing required parameters');
    return [];
  }

  const cube = cube1;
  
  // Validate dimensions
  const width = Number(cube.width_X);
  const height = Number(cube.height_Y);
  const depth = Number(cube.depth_Z);

  if (width <= 0 || height <= 0 || depth <= 0) {
    console.warn('Invalid container dimensions, using defaults');
  }

  // Load textures with fallback
  const texture_side = loadTexture(texturePaths.side);
  const texture_front = loadTexture(texturePaths.front);

  // Create materials with fallback colors if textures fail to load
  const createMaterial = (texture, fallbackColor = 0x888888) => {
    const materials = [];
    
    if (texture) {
      materials.push(new THREE.MeshBasicMaterial({ 
        map: texture,
        transparent: true,
        opacity: opacity
      }));
    } else {
      // Fallback to colored material
      materials.push(new THREE.MeshBasicMaterial({ 
        color: fallbackColor,
        transparent: true,
        opacity: opacity * 0.7
      }));
    }

    // Add wireframe if enabled
    if (showWireframe) {
      materials.push(new THREE.MeshBasicMaterial({
        color: 0x000000,
        wireframe: true,
        transparent: true,
        opacity: 0.3
      }));
    }

    return materials.length === 1 ? materials[0] : materials;
  };

  const material_side = createMaterial(texture_side, 0x3498db); // Blue fallback
  const material_front = createMaterial(texture_front, 0x2ecc71); // Green fallback

  // Create container sides
  const createSide = (material, scaleX, scaleY, position, rotation = { x: 0, y: 0, z: 0 }) => {
    const plane = new THREE.Mesh(
      new THREE.PlaneGeometry(1, 1),
      material
    );
    plane.scale.set(scaleX, scaleY, 1);
    plane.position.set(position.x, position.y, position.z);
    plane.rotation.set(rotation.x, rotation.y, rotation.z);
    
    // Add userData for identification
    plane.userData = {
      type: 'containerSide',
      face: position.face || 'unknown',
      originalScale: { x: scaleX, y: scaleY }
    };
    
    return plane;
  };

  const sides = [
    createSide(material_front, width, height, 
      { x: width / 2, y: height / 2, z: 0, face: 'front' }
    ),
    
    createSide(material_front, width, height, 
      { x: width / 2, y: height / 2, z: depth, face: 'back' }, 
      { x: 0, y: Math.PI, z: 0 }
    ),
    
    createSide(material_side, depth, height, 
      { x: 0, y: height / 2, z: depth / 2, face: 'left' }, 
      { x: 0, y: Math.PI / 2, z: 0 }
    ),
    
    createSide(material_side, depth, height, 
      { x: width, y: height / 2, z: depth / 2, face: 'right' }, 
      { x: 0, y: -Math.PI / 2, z: 0 }
    )
  ];

  // Add all sides to the group
  sides.forEach(side => {
    group_of_cargo_area_attribute.add(side);
  });

  console.log(`Created container visualization: ${width}x${height}x${depth}`);
  return sides;
}

// Cleanup function to dispose of textures
export function disposeContainerTextures() {
  textureCache.forEach(texture => {
    texture.dispose();
  });
  textureCache.clear();
}